<template>
  <tr 
    :class="{ 'has-link': hasLink }"
    @click.prevent="toLink">
    <td 
      v-for="(column, index) in columns"
      :class="cssClass(column)"
      :key="index">
      <component 
        :is="column.component"
        :value="getValue(index)">
      </component>
    </td>
  </tr>
</template>

<script>
import DateTimeValue from '@/DataType/DateTimeValue.vue'
import LinkValue from '@/DataType/LinkValue.vue'
import TextValue from '@/DataType/TextValue.vue'

export default { 
  name: 'DataRow',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  components: {
    DateTimeValue, LinkValue, TextValue
  },
  methods: {
    cssClass (column) {
      let arr = []
      if (column.hidden) {
        arr.push('hide')
      }
      if (column.id == this.sorting.field) {
        arr.push('active')
      }

      if (column.css_class) {
        arr.push(column.css_class)
      }
      return (arr.length ? arr.join(' ') : '')
    },
    toLink () {
      if (this.hasLink) {
        window.open(this.row.Link, '_blank')
      }
    },
    getValue (index) {
      return this.row[index]
    }
  },
  computed: {
    columns () {
      return this.$store.getters.columns
    },
    hasLink () {
      return ('Link' in this.row)
    },
    params () {
      return this.$store.getters.params
    },
    sorting () {
      if (this.params) {
        return this.params.sorting
      }
      return false
    }
  }
}
</script>
